import { render, staticRenderFns } from "./OfficeTabView.vue?vue&type=template&id=0bbadd6e&"
import script from "./OfficeTabView.vue?vue&type=script&lang=js&"
export * from "./OfficeTabView.vue?vue&type=script&lang=js&"
import style0 from "./OfficeTabView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports